import { GraphQLClient, gql } from 'graphql-request'
import { csrfToken } from './restClient'
import baseUrl from './baseUrl'

const graphQLClient = (query, variables, signal, endpoint = '/graphql') => {
  const baseURL = baseUrl()
  const headers = { 'X-CSRF-Token': csrfToken }
  const url = process.env.STORYBOOK_CHROMATIC_BUILD === 'true' ? endpoint : new URL(endpoint, baseURL)
  const client = new GraphQLClient(url.toString(), { headers, credentials: 'include', signal })
  try {
    return client.request(query, variables)
  } catch (err) {
    return new Error(err)
  }
}

export { graphQLClient, gql }
